import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import Breadcrumbs from 'components/Breadcrumbs';
import { eventDetailsData } from 'sections/Events/FutureOfFreight/data';
import { EventDetails } from 'sections/Events/components/EventDetails';
import styles from 'styles/pages/Events/FutureOfFreight/FutureOfFreight.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  const scrollToHandler = (e: React.MouseEvent, anchorElement: HTMLElement | null) => {
    e.preventDefault();

    if (anchorElement) {
      anchorElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mode="light"
          links={[
            { title: 'Events', href: '/events' },
            { title: 'Future Of Freight', href: '' },
          ]}
        />
        <div className={cn('header__content')}>
          <div className={cn('header__description')}>
            <p className={cn('header__description-suptitle')}>events</p>
            <h1 className={cn('header__description-title')}>Future of Freight Event</h1>
            <div className={cn('header__description-buttons-box')}>
              <a
                onClick={(e) => scrollToHandler(e, document.querySelector('#agenda'))}
                href="#agenda"
                className={cn('header__button')}
              >
                Go to Agenda
              </a>
            </div>
          </div>
          <div className={cn('header__event-details-wrap')}>
            <EventDetails eventDetailsData={eventDetailsData}/>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;